import { Component, OnInit, ElementRef,Renderer2  } from '@angular/core';


@Component({
  selector: 'app-spline',
  templateUrl: './spline.component.html',
  styleUrls: ['./spline.component.css']
})
export class SplineComponent implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    const canvasContainer = this.el.nativeElement.querySelector('#spline-canvas');

    // Create an iframe element dynamically
    const iframe = this.renderer.createElement('iframe');
    this.renderer.setAttribute(iframe, 'src', 'https://my.spline.design/3dpathslines2copy-d422291047388f3b4c07a13fc147991a/');  // Replace with your Spline design URL
    this.renderer.setAttribute(iframe, 'frameborder', '0');
    this.renderer.setStyle(iframe, 'width', '100%');
    this.renderer.setStyle(iframe, 'height', '100vh');  // You can adjust height based on your layout
    
    // Append the iframe to the div
    this.renderer.appendChild(canvasContainer, iframe);
  }

}
